import {
  ComingSoonAction,
  comingSoonLead,
  useComingSoonContext,
} from "@/home/ComingSoonFor";
import { PlaceholderScreen } from "@/shell/PlaceholderScreen";
import { OrdersIcon } from "@/ui/icons/OrdersIcon";

export default function Orders() {
  const context = useComingSoonContext();
  return (
    <PlaceholderScreen
      title="Orders"
      testID="placeholder-orders"
      Icon={OrdersIcon}
      tile="tileGreen"
      message={comingSoonLead(
        "Your orders and their delivery status will be here.",
        context.who,
      )}
      homeLink
    >
      <ComingSoonAction context={context} />
    </PlaceholderScreen>
  );
}
